import Api from '@/api/api'

export default {
    getVehicleTypes() {
        return Api.get('SaasAdmin/VehicleType/GetVehicleType')                
    },
    removeVehicleType(id) {
        return Api.delete('SaasAdmin/VehicleType/DeleteVehicleType?Id=' + id);
    },
    addVehicleType(data) {
        return Api.post('SaasAdmin/VehicleType/AddVehicleType', data)
    },
    getVehicleTypeById(id) {
        return Api.get('SaasAdmin/VehicleType/GetVehicleTypeId?Id='+id);
    },
    updateVehicleType(id, data) {
        return Api.put('SaasAdmin/VehicleType/UpdateVehicleType?Id=' + id, data);
    }
}